import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

export default function CollapsiblePanel({
  title,
  preview = null,
  defaultOpen = false,
  className = '',
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`rounded-lg border border-border bg-muted/10 overflow-hidden ${className}`}>
      <button
        type="button"
        className="w-full flex items-center justify-between gap-2 px-3 py-2.5 text-left hover:bg-muted/30 transition-smooth"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className="text-xs font-semibold text-foreground truncate">{title}</span>
        <span className="flex items-center gap-2 shrink-0">
          {preview}
          <Icon
            name="ChevronDown"
            size={16}
            className={`text-muted-foreground transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          />
        </span>
      </button>
      {open ? (
        <div className="px-3 pb-3 pt-2 space-y-3 border-t border-border/60">{children}</div>
      ) : null}
    </div>
  );
}
